<template>
  <div>
    <v-dialog v-model="showDialog" :fullscreen="$vuetify.breakpoint.xsOnly" persistent scrollable>
      <v-card>
        <!-- Header do Modal -->
        <v-toolbar color="primary" dark flat>
          <!-- <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
          <v-toolbar-title class="font-weight-bold">
            <v-icon left>mdi-notebook-edit</v-icon>
            Lançamentos - Educação Inclusiva
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-toolbar-items>
            <v-btn text @click="novoLancamento" color="white" class="mr-2" v-if="matricula">
              <v-icon left small>mdi-plus</v-icon>
              Novo Lançamento
            </v-btn>
          </v-toolbar-items> -->
        </v-toolbar>

        <!-- Conteúdo Principal - Tabela de Lançamentos -->
        <v-card-text class="pa-4 pt-4">
          <!-- Área de Informações do Aluno -->
          <v-row dense class="mb-4">
            <v-col cols="12" md="6">
              <v-card outlined color="blue-grey lighten-5" class="pa-3 rounded-lg">
                <div class="d-flex align-center">
                  <v-avatar color="primary" size="48" class="mr-3">
                    <v-icon dark>mdi-account-school</v-icon>
                  </v-avatar>
                  <div>
                    <div class="text-subtitle-1 font-weight-bold">
                      {{ matricula?.aluno?.nomecompleto || "Nome não disponível" }}
                    </div>
                    <div class="text-caption text--secondary">
                      Código: {{ matricula?.aluno?.codigo || "N/A" }}
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card outlined color="blue-grey lighten-5" class="pa-3 rounded-lg">
                <div class="d-flex align-center">
                  <v-avatar color="green lighten-2" size="48" class="mr-3">
                    <v-icon dark>mdi-account-group</v-icon>
                  </v-avatar>
                  <div>
                    <div class="text-subtitle-1 font-weight-bold">
                      {{ matricula?.turma?.descricao || "Turma não disponível" }}
                    </div>
                    <div class="text-caption text--secondary">
                      Total de lançamentos: {{ lancamentos.length }}
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <!-- Status/Estatísticas -->
          <v-row v-if="!loadingLancamentos && lancamentos.length > 0" class="mb-4">
            <v-col cols="12">
              <v-card outlined class="pa-3 rounded-lg">
                <v-row dense>
                  <v-col cols="4" sm="6" class="text-center">
                    <div class="text-caption text--secondary">
                      Lançamento com a data mais recente
                    </div>
                    <div class="text-h6 font-weight-bold primary--text">
                      {{ ultimoRegistro }}
                    </div>
                  </v-col>
                  <v-col cols="4" sm="6" class="text-center">
                    <div class="text-caption text--secondary">Total de Registros</div>
                    <div class="text-h6 font-weight-bold blue--text">
                      {{ lancamentos.length }}
                    </div>
                  </v-col>
                  <!-- <v-col cols="6" sm="3" class="text-center">
                    <div class="text-caption text--secondary">Bimestre Atual</div>
                    <div class="text-h6 font-weight-bold green--text">
                      {{ bimestreAtual }}
                    </div>
                  </v-col> -->
                  <!-- <v-col cols="4" sm="4" class="text-center">
                    <div class="text-caption text--secondary">Status</div>
                    <v-chip
                      small
                      :color="lancamentos.length > 0 ? 'success' : 'warning'"
                      dark
                      class="mt-1"
                    >
                      {{ lancamentos.length > 0 ? "Possui registros" : "Sem registros" }}
                    </v-chip>
                  </v-col> -->
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <v-card class="elevation-2 mt-4">
            <!-- Header da Tabela -->
            <v-card-title class="py-3">
              <v-icon left color="primary">mdi-history</v-icon>
              Lançamentos
              <v-spacer></v-spacer>
              <!-- <v-text-field
                v-model="searchLancamentos"
                append-icon="mdi-magnify"
                label="Buscar..."
                single-line
                hide-details
                dense
                outlined
                class="mb-0"
                style="max-width: 300px"
              ></v-text-field> -->
            </v-card-title>

            <!-- Loading State -->
            <div v-if="loadingLancamentos" class="text-center py-12">
              <v-progress-circular
                indeterminate
                color="primary"
                size="64"
                width="5"
              ></v-progress-circular>
              <div class="mt-4 text-subtitle-1 text--secondary">Carregando lançamentos...</div>
            </div>

            <!-- Empty State -->
            <div v-else-if="lancamentos.length === 0" class="text-center py-12">
              <v-icon size="64" color="grey lighten-2">mdi-note-outline</v-icon>
              <div class="text-h6 text--secondary mt-4">Nenhum lançamento registrado</div>
              <div class="text-body-1 text--secondary mt-2">
                Comece adicionando um novo lançamento
              </div>
              <v-btn color="primary" class="mt-4" @click="novoLancamento" v-if="matriculaId">
                <v-icon left>mdi-plus</v-icon>
                Adicionar Primeiro Lançamento
              </v-btn>
            </div>

            <!-- Tabela de Lançamentos -->
            <v-data-table
              v-else
              :headers="headersLancamentos"
              :items="filteredLancamentos"
              :search="searchLancamentos"
              :items-per-page="10"
              class="elevation-0"
              mobile-breakpoint="0"
            >
              <!-- Template para Cabeçalho -->
              <!-- <template v-slot:header="{ props }">
                <thead>
                  <tr>
                    <th
                      v-for="header in props.headers"
                      :key="header.value"
                      :class="['text-left', 'py-3', header.align ? `text-${header.align}` : '']"
                      :style="header.style"
                    >
                      <span class="font-weight-bold primary--text">
                        {{ header.text }}
                      </span>
                    </th>
                  </tr>
                </thead>
              </template> -->

              <!-- Template para Linhas -->
              <template v-slot:item="{ item }">
                <tr :class="itemRowClass(item)">
                  <td class="font-weight-medium">
                    <div class="d-flex align-center">
                      <v-icon small color="primary" class="mr-2">mdi-calendar</v-icon>
                      {{ item.data_formatada }}
                    </div>
                  </td>
                  <td>
                    <v-chip
                      small
                      :color="getBimestreColor(item.bimestre)"
                      dark
                      class="font-weight-bold"
                    >
                      {{ item.bimestre_desc }}
                    </v-chip>
                  </td>
                  <td>
                    <div class="d-flex align-center">
                      <v-icon small color="grey" class="mr-2">mdi-clock-outline</v-icon>
                      <!-- {{ item }} -->
                      {{ item.horario?.descricao || "N/A" }}
                    </div>
                  </td>
                  <td class="text-nowrap">
                    <div class="d-flex align-center justify-end">
                      <!-- Botão Visualizar -->
                      <v-tooltip color="primary" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            x-small
                            color="primary"
                            class="ml-1"
                            v-bind="attrs"
                            v-on="on"
                            @click="visualizarLancamento(item)"
                          >
                            <v-icon small>fa fa-eye </v-icon>
                          </v-btn>
                        </template>
                        <span>Visualizar Detalhes</span>
                      </v-tooltip>

                      <!-- Botão Editar -->
                      <v-tooltip color="primary" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            x-small
                            color="blue-grey lighten-3"
                            class="ml-1"
                            v-bind="attrs"
                            v-on="on"
                            @click="editarLancamento(item)"
                          >
                            <v-icon small>fa fa-edit</v-icon>
                          </v-btn>
                        </template>
                        <span>Editar Lançamento</span>
                      </v-tooltip>

                      <!-- Botão Excluir -->
                      <v-tooltip color="primary" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            x-small
                            color="error"
                            class="ml-1"
                            v-bind="attrs"
                            v-on="on"
                            @click="excluirLancamento(item)"
                          >
                            <v-icon small>fa fa-trash</v-icon>
                          </v-btn>
                        </template>
                        <span>Excluir Lançamento</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
              </template>

              <!-- Template para rodapé -->
              <template v-slot:footer>
                <v-divider></v-divider>
                <!-- <div class="pa-3 text-caption text--secondary">
                  <v-icon x-small class="mr-1">mdi-information</v-icon>
                  Total de {{ lancamentos.length }} lançamento(s) registrado(s)
                </div> -->
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>

        <!-- Footer do Modal -->
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn class="mr-2 text-white" color="primary" @click="closeDialog"> Fechar </v-btn>
          <!-- <v-btn
            color="primary"
            @click="gerarRelatorioIndividual"
            :disabled="lancamentos.length === 0"
            v-if="matriculaId"
          >
            <v-icon left>mdi-file-pdf-box</v-icon>
            Gerar Relatório AEE
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Modal de Detalhes do Lançamento -->
    <e-modal-detalhes-lancamento-aee
      v-if="dialogDetalhes && matricula"
      :dialog.sync="dialogDetalhes"
      :lancamento="lancamentoSelecionado"
      :matricula="matricula"
    />
  </div>
</template>

<script>
export default {
  name: "EModalLancamentosAEE",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    matriculaId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      matricula: null,
      searchLancamentos: "",
      loadingLancamentos: false,
      lancamentos: [],
      dialogDetalhes: false,
      lancamentoSelecionado: null,
      headersLancamentos: [
        {
          text: "Data",
          value: "data_formatada",
          align: "left",
          width: "20%",
          class: "primary--text",
        },
        {
          text: "Bimestre",
          value: "bimestre_desc",
          align: "left",
          width: "20%",
          class: "primary--text",
        },
        {
          text: "Horário",
          value: "horario.descricao",
          align: "left",
          width: "30%",
          class: "primary--text",
        },
        {
          text: "Ações",
          value: "actions",
          align: "right",
          sortable: false,
          width: "30%",
          class: "primary--text",
        },
      ],
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("update:dialog", value);
      },
    },
    filteredLancamentos() {
      if (!this.searchLancamentos) return this.lancamentos;
      const search = this.searchLancamentos.toLowerCase();
      return this.lancamentos.filter((item) => {
        return (
          item.data_formatada?.toLowerCase().includes(search) ||
          item.bimestre_desc?.toLowerCase().includes(search) ||
          item.horario?.descricao?.toLowerCase().includes(search)
        );
      });
    },
    ultimoRegistro() {
      if (this.lancamentos.length === 0) return "N/A";
      const ultimo = [...this.lancamentos].sort((a, b) => new Date(b.data) - new Date(a.data))[0];
      return ultimo.data_formatada;
    },
    // bimestreAtual() {
    //   if (this.lancamentos.length === 0) return "N/A";
    //   const hoje = new Date();
    //   // Lógica para determinar bimestre atual - ajuste conforme sua necessidade
    //   const bimestres = ["1º", "2º", "3º", "4º"];
    //   const mes = hoje.getMonth();
    //   return bimestres[Math.floor(mes / 3)] || "N/A";
    // },
  },
  watch: {
    dialog(val) {
      if (val && this.matriculaId) {
        this.loadLancamentos();
      } else {
        this.resetState();
      }
    },
  },
  methods: {
    closeDialog() {
      this.showDialog = false;
    },
    resetState() {
      this.matricula = null;
      this.lancamentos = [];
      this.searchLancamentos = "";
      this.loadingLancamentos = false;
      this.lancamentoSelecionado = null;
      this.dialogDetalhes = false;
    },
    async loadLancamentos() {
      if (!this.matriculaId) return;
      this.loadingLancamentos = true;
      try {
        const response = await this.$services.educacaoInclusivaService.listar(this.matriculaId);
        this.matricula = response.matricula;
        this.lancamentos = response.lancamentos.map((lancamento) => ({
          ...lancamento,
          data_formatada: new Intl.DateTimeFormat("pt-BR", {
            timeZone: "UTC",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }).format(new Date(lancamento.data)),
          bimestre_desc:
            this.$constants.bimestres[lancamento.bimestre]?.desc ||
            `Bimestre ${lancamento.bimestre}`,
        }));
        this.lancamentos.sort((a, b) => new Date(b.data) - new Date(a.data));
      } catch (error) {
        this.$handleError(error);
        this.$toast.error("Erro ao carregar lançamentos");
      } finally {
        this.loadingLancamentos = false;
      }
    },
    getBimestreColor(bimestre) {
      const colors = { 1: "blue", 2: "green", 3: "orange", 4: "red" };
      return colors[bimestre] || "grey";
    },
    itemRowClass(item) {
      const hoje = new Date();
      const dataRegistro = new Date(item.data);
      const diffTempo = hoje.getTime() - dataRegistro.getTime();
      const diffDias = diffTempo / (1000 * 3600 * 24);
      if (diffDias <= 7) return "blue-lighten-5";
      return "";
    },
    editarLancamento(item) {
      if (this.matriculaId) {
        this.$router.push({
          name: "educacaoInclusiva.edit",
          params: { matricula_id: this.matriculaId, lancamento_id: item.id },
        });
        this.closeDialog();
      }
    },
    novoLancamento() {
      if (this.matriculaId) {
        this.$router.push({
          name: "educacaoInclusiva.create",
          params: { matricula_id: this.matriculaId },
        });
        this.closeDialog();
      }
    },
    visualizarLancamento(item) {
      this.lancamentoSelecionado = item;
      this.dialogDetalhes = true;
    },
    async excluirLancamento(item) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza de que deseja apagar este lançamento?",
        confirmationCode: item.id,
        confirmationMessage: `Por favor, digite <strong>${item.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => this.$modals.close(),
            props: { color: "warning", small: true },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Excluindo lançamento...");
              try {
                await this.$services.educacaoInclusivaService.remover(item.id);
                const index = this.lancamentos.findIndex((l) => l.id === item.id);
                if (index > -1) this.lancamentos.splice(index, 1);
                this.$toast.success("Lançamento excluído com sucesso!");
              } catch (error) {
                this.$handleError(error);
              } finally {
                this.$loaderService.close();
              }
            },
            props: { color: "error", small: true },
          },
        ],
      });
    },
    async gerarRelatorioIndividual() {
      if (this.matriculaId) {
        this.$loaderService.open("Gerando relatório...");
        try {
          await this.$services.relatoriosService.relatorioAee(parseInt(this.matriculaId, 10));
          this.$toast.success("Relatório gerado com sucesso!");
        } catch (error) {
          this.$handleError(error);
        } finally {
          this.$loaderService.close();
        }
      }
    },
  },
};
</script>

<style scoped>
/* Estilos específicos para o modal */
.v-dialog {
  border-radius: 12px !important;
}
.v-card {
  border-radius: 12px;
}
.v-data-table {
  border-radius: 8px;
}
.v-data-table >>> tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}
@media (max-width: 600px) {
  .v-toolbar__title {
    font-size: 1rem;
  }
  .v-card__title {
    padding: 16px 12px !important;
  }
  .v-card__text {
    padding: 12px !important;
  }
  .v-chip {
    font-size: 0.7rem;
    height: 24px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.v-card-text::-webkit-scrollbar {
  width: 8px;
}
.v-card-text::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.v-card-text::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.v-card-text::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
